module.exports = __webpack_public_path__ + "static/media/Hanson-Bold.daa47eba.ttf";